function App() {
	return (
		<div className="flex items-center justify-center h-screen bg-gray-200 dark:bg-gray-900">
			<h1 className="text-5xl md:text-8xl lg:text-9xl text-center font-serif italic dark:text-gray-200 animate-pulse">Nosy News...</h1>
		</div>
	)
}

export default App;